<template>
    <div class="own-custom-select-wrap" 
        :class="[{ 'own-disabled': disabled }, { 'active': show}]" 
        ref="ownCustomSelectWrap"        
    >              
        <div class="input-wrap">
            <input                 
                type="text" 
                v-model="localValue" 
                :disabled="disabled" 
                readonly tabindex="-1" 
                :placeholder="placeholder" 
                @focus="show = true"                  
                v-bind="attrs"              
            />                        
            <img class="icon" src="@/assets/img/icons/ic-select-down-blue.svg" />
        </div>
        <div class="own-custom-select-wrap__inner-wrap">
            <slot ></slot>                        
        </div>
    </div>
</template>

<script>
export default {
    name: 'OwnSelect',
    props:{
        disabled:Boolean,
        placeholder: String,        
        multiple: Boolean
    },       
    data(){
        return{
            localValue: '',                                        
            show:false,            
            multipleTextAll:{},            
            OwnSelect:{
                modelValue: this.localValue,
                setValue: this.setValue,
                multiple: this.multiple,
                setValueMultiply: this.setValueMultiply,                                
                setMultiplyTextAll: this.setMultiplyTextAll, 
                setLocalValueText: this.setLocalValueText                            
            },            
        }
    },
    computed:{
        attrs () {            
            return {
                ...this.$attrs                
            }
        },       
    },
    provide(){
        const OwnSelect = this.OwnSelect

        return { OwnSelect }
    },
    watch:{
        localValue(){
            if (!this.multiple){
                this.emitSelected()
            } else {
                this.emitMultiplySelected()                
            }
            
        },
        attrs:{
            immediate: true,
            handler () {
                let _this = this
                if (this.attrs) {                    
                    _this.OwnSelect.modelValue = _this.attrs.value   
                    
                    if (!_this.multiple){
                        _this.localValue = _this.attrs.value
                    }
                }                
                
            }      
        },  
        OwnSelect:{
            deep:true,
            handler(){           
                if (this.multiple)                     {
                    this.setLocalValueTextMain()                                
                }                
            }
        }     
    },
    methods:{
        setValue (newValue) {
            this.OwnSelect.modelValue = newValue    
            this.localValue = newValue  
            this.show = false      
        },    
        setValueMultiply(newValue){
            let _this = this
            var newValueIndex = _this.OwnSelect.modelValue.indexOf(newValue)
                        
            if (newValueIndex > -1){
                _this.OwnSelect.modelValue.splice(newValueIndex, 1)                    
            } else {
                _this.OwnSelect.modelValue.push(newValue)                     
            }
            
        },
        isClickOutside(event){            
            let _this = this
            let el = this.$refs.ownCustomSelectWrap

            if ( !(el == event.target || el.contains(event.target)) ){
                // outside the element
                _this.show = false
            } 
        },  
        emitSelected () {                    
            this.$emit('input', this.localValue)            
        },
        emitMultiplySelected(){
            // this.$emit('change', this.localValueMultiply)            
            this.$emit('change', this.OwnSelect.modelValue)       
        },       
        setMultiplyTextAll(text, value){
            this.multipleTextAll[value] = text    
        },
       
        setLocalValueTextMain(){
            let _this = this
            this.localValue = ''

            this.OwnSelect.modelValue.forEach(element => {
                if (_this.multipleTextAll){
                    let keyArray = Object.keys(_this.multipleTextAll)                    
                    if (keyArray.indexOf(element) > -1){
                        _this.localValue = _this.localValue.concat(_this.multipleTextAll[element], ', ')
                    }
                }
            });
        }
    },   
    created() {        
        document.getElementsByTagName('body')[0].addEventListener('click', this.isClickOutside)               
    },       
    beforeDestroy(){
        document.getElementsByTagName('body')[0].removeEventListener('click', this.isClickOutside)
    }
}
</script>

<style lang="scss">

    .own-custom-select-wrap{
        position: relative;
        // z-index: 5;        

        &__inner-wrap{
            display: none;
            position: absolute;
            top:40px;
            left:0;
            background: white;
            z-index: 2;
            box-shadow: 0 5px 10px rgba(0,0,0,0.3);
            width: 100%;
            padding: 20px 0;            
            border-radius: 4px;
        }

        &.active{
            .own-custom-select-wrap__inner-wrap{
                display: block;                
            }   
        }

        .input-wrap{
            input[type=text]{
                padding-right: 40px;
                cursor: pointer;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
            }
            .icon{                                
                position: absolute;
                right: 10px;
                top:10px;
                width: 15px!important;                
            }
        }
                 
    }
</style>